function hasExtension(url: string, exts: string[]) {
  try {
    const path = url.split('?')[0].toLowerCase();
    return exts.some((ext) => path.endsWith(ext));
  } catch {
    return false;
  }
}

export const isImageUrl = (url: string): boolean => {
  if (url.startsWith('data:')) return url.startsWith('data:image/');
  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg', '.ico'];
  return hasExtension(url, imageExtensions);
};

export const isVideoUrl = (url: string): boolean => {
  if (url.startsWith('data:')) return url.startsWith('data:video/');
  const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.wmv', '.flv', '.mkv'];
  return hasExtension(url, videoExtensions);
};
